import { Dispatch, SetStateAction, lazy } from 'react'
import { IWarehouse } from 'safe'
const LocationCard = lazy(() => import('./LocationCard'));

const ShowLocations: React.FC<ShowLocationProps> = ({
  showLocations,
  setShowLocations,
  setSearchLocation,
  filterText,
  locations,
  setLocation,
  getExistencesByWarehouse = () => {},
  notToShow,
}) => {
  const filterLocations = (location: IWarehouse) => {
    if (notToShow && location.id === notToShow.id) return false
    if (location.name.toLowerCase().indexOf(filterText.toLowerCase()) >= 0)
      return true
    return false
  }

  if (showLocations) {
    return (
      <>
        {locations.filter(filterLocations).map((location) => (
          <LocationCard
            key={location.id}
            location={location}
            setLocation={() => {
              setLocation(location)
              setShowLocations(false)
              setSearchLocation(location.name)
              // getExistencesByWarehouse(location)
            }}
          />
        ))}
      </>
    )
  }

  return <></>
}

export default ShowLocations

interface ShowLocationProps {
  showLocations: boolean
  setShowLocations: Dispatch<SetStateAction<boolean>>
  setSearchLocation: Dispatch<SetStateAction<string>>
  filterText: string
  locations: IWarehouse[]
  setLocation: Dispatch<SetStateAction<IWarehouse | null>>
  getExistencesByWarehouse?: Function
  notToShow: IWarehouse | null
}
